import React, { useState, useContext, useEffect } from 'react'

const defaultState = {
    loggedIn: false,
    setLoggedIn: () => {},
}
export const AuthContext = React.createContext(defaultState)

export const AuthIsSignedIn = ({ children }) => {
    const { loggedIn } = useContext(AuthContext)
    return <>{loggedIn ? children : null}</>
}

export const AuthIsNotSignedIn = ({ children }) => {
    const { loggedIn } = useContext(AuthContext)

    return <>{!loggedIn ? children : null}</>
}

export const AuthProvider = ({ children }) => {
    const [loggedIn, setLoggedIn] = useState(false)

    useEffect(() => {
        console.log(loggedIn)
    }, [loggedIn])

    const state = {
        loggedIn,
        setLoggedIn
    }

    return <AuthContext.Provider value={state}>{children}</AuthContext.Provider>
}

export default AuthProvider
